import type { ProfileTab } from './types'
import { MOCK_CLIENTS as GENERATED_CLIENTS } from './mockClients.generated'
import {
  displayName as storeDisplayName,
  getAllClients,
  getClientById as storeGetClientById,
  statusCounts as storeStatusCounts,
} from './clientStore'

/** Live roster = session-added clients + captured list. */
export const MOCK_CLIENTS = GENERATED_CLIENTS
export { getAllClients }

export const PROFILE_TABS: ProfileTab[] = [
  { id: 'face-sheet', label: 'Face Sheet', implemented: true },
  { id: 'admission', label: 'Admission', implemented: true },
  { id: 'nursing', label: 'Nursing', implemented: true },
  { id: 'social', label: 'Social', implemented: true },
  { id: 'activity', label: 'Activity', implemented: true },
  { id: 'dietary', label: 'Dietary', implemented: true },
  { id: 'hp', label: 'H&P', implemented: true },
  { id: 'immunization', label: 'Immun', implemented: true },
  { id: 'notes', label: 'Notes', implemented: true },
  { id: 'care-plans', label: 'Care Plans', implemented: true },
  { id: 'assessments', label: 'Assmnts', implemented: true },
  { id: 'vitals', label: 'Vitals', implemented: true },
  { id: 'mars', label: 'MARS', implemented: true },
  { id: 'adls', label: 'ADLS', implemented: true },
  { id: 'hospitalization', label: 'Hospitalization', implemented: true },
  { id: 'documents', label: 'Documents', implemented: true },
  { id: 'incident', label: 'Incident', implemented: true },
  { id: 'orders', label: 'Orders', implemented: true },
  { id: 'log', label: 'Log', implemented: true },
  { id: 'sdoh', label: 'SDOH', implemented: true },
  { id: 'adv-adl', label: 'ADV ADL', implemented: true },
  { id: 'upload-pic', label: 'Upload Pic', implemented: true },
  { id: 'schedule', label: 'Schedule', implemented: true },
]

export const MODULE_NAV = [
  { id: 'clients', label: 'Clients', path: '/clients', active: true },
  { id: 'transport', label: 'Transport', path: '/modules/transport' },
  { id: 'timecard', label: 'Time Card', path: '/modules/timecard' },
  { id: 'clinical', label: 'Clinical', path: '/modules/clinical' },
  { id: 'activities', label: 'Activities', path: '/modules/activities' },
  { id: 'food', label: 'Food', path: '/modules/food' },
  { id: 'reports', label: 'Reports', path: '/modules/reports' },
  { id: 'admin', label: 'Admin', path: '/modules/admin' },
  { id: 'billing', label: 'Billing', path: '/modules/billing' },
  { id: 'crm', label: 'CRM', path: '/modules/crm' },
  { id: 'referrals', label: 'Referral', path: '/modules/referrals' },
  { id: 'tasks', label: 'Tasks', path: '/modules/tasks' },
  { id: 'rpm', label: 'RPM', path: '/modules/rpm' },
  { id: 'organize', label: 'Organize', path: '/modules/organize' },
] as const

export const getClientById = storeGetClientById
export const displayName = storeDisplayName
export const statusCounts = storeStatusCounts
